import Vue from "vue";
import VueRouter from "vue-router";
import Store from "@/store";
import SearchList from "@/views/search-list/Index.vue";
import NotFound from "@/views/error-pages/NotFound.vue";

Vue.use(VueRouter);

// 自动加载模块路由
function autoImport() {
  const files = require.context("./modules", false, /.js$/);
  const routes = files.keys().reduce((routes, file) => {
    routes.push(...files(file).default);
    return routes;
  }, []);
  return routes;
}
const importRoutes = autoImport();
const routes = [
  {
    path: "/",
    name: "search-list",
    component: SearchList,
    meta: {
      cache: true,
    },
  },
  {
    path: "/article/:id",
    name: "article",
    component: () =>
      import(/* webpackChunkName: "detail" */ "@/views/article/Index.vue"),
  },
  {
    path: "/video/:id",
    name: "video",
    component: () =>
      import(/* webpackChunkName: "detail" */ "@/views/video/Index.vue"),
  },
  {
    path: "/wallchart/:id",
    name: "wallchart",
    component: () =>
      import(/* webpackChunkName: "detail" */ "@/views/wallchart/Index.vue"),
  },
  ...importRoutes,
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
    meta: {
      title: "404-页面找不到了",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve({ ...savedPosition, behavior: "smooth" });
        } else {
          resolve({ x: 0, y: 0, behavior: "smooth" });
        }
      }, 100);
    });
  },
});

/**
 * 修改页面标题
 */
function changeTitle(to) {
  // 分隔符
  const separator = " — ";
  // 根标题
  const rootTitle = document.title.split(separator).reverse()[0];
  // 根据路由匹配获取有效的title列表
  const titleList = to.matched
    .map((item) => {
      let title = "";
      if (typeof item?.meta?.title === "function") {
        title = item.meta.title(to);
      } else {
        title = item?.meta?.title ?? "";
      }
      return title;
    })
    .filter((item) => item)
    .reverse();
  const title = [...titleList, rootTitle].join(separator);
  document.title = title;
}

/**
 * 组件缓存处理
 * @param {Route} to 即将要进入的目标 路由对象
 * @param {Route} from 当前导航正要离开的路由
 */
function cacheComponents(to, from) {
  if (from.name !== to.name) {
    // 添加组件缓存，只要进来的路由cache为true或数组长度不为0就直接缓存
    if (
      (Array.isArray(to?.meta?.cache ?? false) &&
        (to?.meta?.cache?.length ?? 0 > 0)) ||
      (to?.meta?.cache ?? false === true)
    ) {
      // 只要meta.cache有值且不是假值就缓存起来
      Store.commit("ADD_COMPONENTS", to.name);
    }

    // 移除组件缓存，
    // 1、循环cache值为数组的路由，
    // 2、该路由在组件缓存中
    // 3、并且该路由的cache不包含to.name
    // 4、并且当前路由也不是to.name
    // 那就从组件缓存中移除
    for (const route of router
      .getRoutes()
      .filter((route) => Array.isArray(route?.meta?.cache ?? false))) {
      if (
        Store.state.cacheComponents.includes(route.name) &&
        !route.meta.cache.includes(to.name) &&
        to.name !== route.name
      ) {
        Store.commit("REMOVE_COMPONENTS", route.name);
      }
    }
  }
}

router.beforeEach((to, from, next) => {
  // 路由发生变化修改页面title
  changeTitle(to);
  // 处理组件缓存
  cacheComponents(to, from);
  // 检测是否为手机
  Store.dispatch("detectMobile");

  next();
});

export default router;
